import { render } from "./index.vue?vue&type=template&id=387f3568&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=387f3568&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=387f3568&lang=css"

import exportComponent from "/root/workspace/service-web_xMds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387f3568"]])

export default __exports__